import { Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { useEffect, useRef, useState } from 'react';
import {
  getBranchesFilterData,
  getMerchantFilterData,
} from '../../helpers/filters.helpers';
import useAuth from '../../hooks/useAuth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useDidMountEffect from '../../hooks/useDidMountEffect';
import {
  EntityFilterData,
  EntityIdFilterData,
  SelectData,
} from '../../type/filter.types';

interface Props {
  filterSelectData: UseFormReturnType<EntityFilterData>;
  filterValues: UseFormReturnType<EntityIdFilterData>;
  isMerchantDependent?: boolean;
  error?: React.ReactNode;
}

function SelectBranchFilter(props: Props) {
  const { filterSelectData, filterValues, isMerchantDependent, error } = props;
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const noData = 'No data';
  const loadingData = 'Loading...';

  const loadBranches = async (
    partnerId?: string,
    resellerId?: string,
    merchantId?: string
  ) => {
    setIsLoading(true);

    const branches = await getBranchesFilterData(
      axiosPrivate,
      partnerId,
      resellerId,
      merchantId
    );

    filterSelectData.setFieldValue('branchesData', branches);

    setIsLoading(false);
  };

  useEffect(() => {
    if (!isMerchantDependent) {
      loadBranches();
    }
  }, []);

  useDidMountEffect(() => {
    if (!isMerchantDependent) {
      return;
    }

    if (
      filterValues.values.merchant &&
      filterValues.values.merchant !== noData
    ) {
      loadBranches(
        filterValues.values.partner,
        filterValues.values.reseller,
        filterValues.values.merchant
      );
    } else {
      filterValues.setFieldValue('branch', '');
      filterSelectData.setFieldValue('branchesData', []);
    }
  }, [filterValues.values.merchant]);

  const getData = () => {
    let data = isLoading
      ? [loadingData]
      : filterSelectData.values.branchesData?.length === 0 ||
        filterSelectData.values.branchesData === undefined
      ? [noData]
      : filterSelectData.values.branchesData;

    if (isMerchantDependent) {
      data = isLoading
        ? [loadingData]
        : (filterSelectData.values.branchesData?.length === 0 &&
            filterValues.values.merchant) ||
          filterSelectData.values.branchesData === undefined
        ? [noData]
        : filterSelectData.values.branchesData;
    }

    return data;
  };

  const getValue = () => {
    let value = isLoading
      ? loadingData
      : filterSelectData.values.branchesData?.length === 0 ||
        filterSelectData.values.branchesData === undefined
      ? noData
      : filterValues.values.branch;

    if (isMerchantDependent) {
      value = isLoading
        ? loadingData
        : (filterSelectData.values.branchesData?.length === 0 &&
            filterValues.values.merchant) ||
          filterSelectData.values.branchesData === undefined
        ? noData
        : filterValues.values.branch;
    }

    return value;
  };

  const getDisabled = () => {
    let disabled =
      isLoading ||
      filterSelectData.values.branchesData?.length === 0 ||
      filterSelectData.values.branchesData === undefined;

    if (isMerchantDependent) {
      disabled =
        isLoading ||
        filterSelectData.values.branchesData?.length === 0 ||
        filterSelectData.values.branchesData === undefined ||
        !filterValues.values.merchant;
    }
    return disabled;
  };

  return (
    <>
      <Select
        label='Select Merchant Branch'
        data={getData()}
        value={getValue()}
        disabled={getDisabled()}
        onChange={(value: string) =>
          filterValues.setFieldValue('branch', value)
        }
        clearable={!getDisabled()}
        searchable
        error={error}
      />
    </>
  );
}

export default SelectBranchFilter;
